import { render, staticRenderFns } from "./areaList.vue?vue&type=template&id=3eabec3a&scoped=true"
import script from "./areaList.vue?vue&type=script&lang=js"
export * from "./areaList.vue?vue&type=script&lang=js"
import style0 from "./areaList.vue?vue&type=style&index=0&id=3eabec3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eabec3a",
  null
  
)

export default component.exports